import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const CommentsSection = ({ comments, onAddComment }) => {
  const [newComment, setNewComment] = useState('');

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (newComment?.trim()) {
      onAddComment(newComment);
      setNewComment('');
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-card">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="MessageSquare" size={20} color="var(--color-primary)" />
        <h2 className="text-lg font-semibold text-foreground">Comments & Communication</h2>
      </div>
      <form onSubmit={handleSubmit} className="mb-6">
        <div className="flex gap-3">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name="User" size={20} color="var(--color-primary)" />
          </div>
          <div className="flex-1">
            <textarea
              value={newComment}
              onChange={(e) => setNewComment(e?.target?.value)}
              placeholder="Add a comment..."
              className="w-full px-4 py-3 bg-background border border-border rounded-lg text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/20 resize-none"
              rows="3"
            />
            <div className="flex justify-end mt-2">
              <Button 
                type="submit" 
                variant="default" 
                size="sm"
                disabled={!newComment?.trim()}
              >
                Post Comment
              </Button>
            </div>
          </div>
        </div>
      </form>
      <div className="space-y-4">
        {comments?.length === 0 ? (
          <div className="text-center py-8 text-muted-foreground">
            <Icon name="MessageSquare" size={48} className="mx-auto mb-2 opacity-20" />
            <p className="text-sm">No comments yet</p>
          </div>
        ) : (
          comments?.map((comment) => (
            <div key={comment?.id} className="flex gap-3">
              <div className="w-10 h-10 rounded-full overflow-hidden border-2 border-border flex-shrink-0">
                <Image 
                  src={comment?.avatar} 
                  alt={comment?.avatarAlt}
                  className="w-full h-full object-cover"
                />
              </div>
              
              <div className="flex-1">
                <div className="bg-muted/50 rounded-lg p-3">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-sm font-medium text-foreground">{comment?.author}</span>
                    <span className="text-xs text-muted-foreground">{comment?.role}</span>
                    <span className="text-xs text-muted-foreground">•</span>
                    <span className="text-xs text-muted-foreground">{comment?.timestamp}</span>
                  </div>
                  <p className="text-sm text-foreground">{comment?.content}</p>
                </div>
                
                {comment?.attachments && comment?.attachments?.length > 0 && (
                  <div className="flex gap-2 mt-2">
                    {comment?.attachments?.map((attachment, index) => (
                      <div key={index} className="flex items-center gap-1 px-2 py-1 bg-accent/10 rounded text-xs text-accent">
                        <Icon name="Paperclip" size={12} />
                        <span>{attachment}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CommentsSection;